exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contentTooltipInter{max-width:20%!important;min-width:10%!important}@media (max-width:768px){.contentTooltipInter{max-width:85vw!important;min-width:70vw!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bae30e8c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/climan/components/graphCtxResult.vue
// module id = 1425
// module chunks = 2